<section>
    <div class="flex justify-between items-end">
        <div>
            <h1>Message Broadcasting</h1>
        </div>
        <div class="flex gap-2 items-center">
            <button class="btn btn-sm ">Cancel</button>
            <button class="btn btn-sm btn-primary" (click)="onSubmit()"><i class="ri-draft-line font-normal"></i> Save as Draft</button>
            <button class="btn btn-sm btn-primary" (click)="onSubmit(true)">Send <i class="ri-send-plane-fill"></i></button>
        </div>
    </div>


    <div class="bg-white p-10 border rounded-lg mt-10">

        <form [formGroup]="messageForm" (submit)="onSubmit()">
            <ul>
                <!-- recipient -->
                <li class="grid grid-cols-3">
                    <span class="font-mono italic capitalize">recipient :</span>
                    <div class=" col-span-2">



                        <div class="dropdown dropdown-end mt-1 w-full max-w-sm">
                            <input type="text" placeholder="Search User" class="input input-bordered  w-full"
                                (input)="onUserSearch($event)">
                            <div tabindex="0"
                                class="dropdown-content menu bg-base-100 rounded-box z-[1] w-full p-2 mt-2 grid grid-cols-1 min-h-[7rem] max-h-[15rem] overflow-y-auto border shadow-xl">

                                @if (users && users.length > 0) {
                                @for (i of users; track $index) {
                                @if(!isUserSelected(i.id)) {
                                <button type="button" class="p-3 rounded-md cursor-pointer hover:bg-zinc-100 text-start"
                                    (click)="onSelectUser(i)">
                                    <p class="font-semibold">{{i.first_name}} {{i.last_name}}</p>
                                    <Span class="text-xs font-normal capitalize text-zinc-500">Role:
                                        {{"Student"}}</Span>
                                </button>
                                }
                                }
                                }@else {
                                <div class="p-3 rounded-md text-center">
                                    <p class="text-zinc-500 font-mono italic">Loading...</p>
                                </div>
                                }


                            </div>
                        </div>


                        <div class="flex gap-2 flex-wrap mt-5">
                            @for (i of selectedUsers; track $index) {
                            <button type="button" class="btn btn-sm rounded-full items-center capitalize bg-white border"
                                (click)="removeUser($index)"><span class="flex items-center gap-0.5"><i
                                        class="ri-user-6-line text-base text-blue-600"></i>{{i.name}}</span> <i
                                    class="ri-close-line "></i></button>
                            }
                        </div>



                    </div>
                </li>
                <!-- recipient -->
                <li>
                    <hr class="my-5">
                </li>
                <!-- title -->
                <li class="grid grid-cols-3">
                    <span class="font-mono italic capitalize">title :</span>
                    <div class="col-span-2">

                        <div class="flex gap-2 items-center">
                            <input type="text" formControlName="topic" class="input input-ghost w-full" placeholder="Title" />

                            <div class="dropdown dropdown-end">
                                <div tabindex="0" role="button" class="btn btn-sm btn-circle"><i
                                        class="ri-emotion-happy-line font-normal text-lg"></i></div>
                                <div tabindex="0"
                                    class="dropdown-content menu bg-base-100 rounded-box z-[1] w-auto p-0 mt-2 shadow">
                                    <emoji-mart (emojiClick)="addEmoji($event)"  title="Pick your emoji…" emoji="point_up"></emoji-mart>
                                </div>
                            </div>
                            <!-- <button class="btn btn-circle btn-sm"><i class="ri-mic-line"></i></button> -->

                        </div>

                    </div>
                </li>
                <!-- title -->
                <li>
                    <hr class="my-5">
                </li>
                <!-- message -->
                <li class="grid grid-cols-3">
                    <span class="font-mono italic capitalize">message :</span>
                    <div class="col-span-2">
                        <quill-editor formControlName="message"  format="text" theme="snow"></quill-editor>
                    </div>
                </li>
                <!-- message -->
                <li>
                    <hr class="my-5">
                </li>
                <!-- recischedule messagepient -->
                <li class="grid grid-cols-3">
                    <span class="font-mono italic capitalize">schedule message :</span>
                    <div class="col-span-2 flex items-center gap-2">

                        <label class="w-[15rem] input input-sm input-bordered flex items-center gap-2 input-date">
                            <i class="ri-calendar-line"></i>
                            <input formControlName="schedule_date" type="date" class="grow" placeholder="Daisy" #schedule (focus)="schedule.click()"
                                min="{{ minDate }}" />
                        </label>

                        <label class="w-32 input input-sm input-bordered flex items-center gap-2 input-date">
                            <i class="ri-time-line"></i>
                            <select formControlName="schedule_time" class="w-full max-w-xs">
                                <option disabled selected>Time</option>
                                @for (i of time; track $index) {
                                <option value="{{ i }}">{{ i }}</option>
                                }
                            </select>
                        </label>




                    </div>
                </li>
                <!-- schedule message -->
                <li>
                    <hr class="my-5">
                </li>
                <!-- type -->
                <li class="grid grid-cols-3">
                    <span class="font-mono italic capitalize">type :</span>
                    <div class="col-span-2 flex items-center gap-2">

                        <div>
                            <input type="radio" formControlName="communication_type" hidden value="sms" class="custom-toggle" #type_sms id="sms">
                            <label for="sms" class="capitalize">
                                @if (type_sms.checked == true) {
                                <i class="ri-checkbox-circle-line font-light text-base"></i>
                                }
                                SMS</label>
                        </div>
                        <div>
                            <input type="radio" hidden formControlName="communication_type" value="email" class="custom-toggle" #type_email id="email">
                            <label for="email" class="capitalize">
                                @if (type_email.checked == true) {
                                <i class="ri-checkbox-circle-line font-light text-base"></i>
                                }
                                email</label>
                        </div>
                        <div>
                            <input type="radio" hidden formControlName="communication_type" value="push_notification" class="custom-toggle" #type_push
                                id="push_notification">
                            <label for="push_notification" class="capitalize">
                                @if (type_push.checked == true) {
                                <i class="ri-checkbox-circle-line font-light text-base"></i>
                                }
                                Push Notification</label>
                        </div>


                    </div>
                </li>
                <!-- type -->
            </ul>
        </form>
    </div>



</section>